import { cn } from "@/lib/helpers/cn";
import type { ComponentProps } from "react";

type Props = ComponentProps<"main">;

export function ContainerContent({ children }: Props) {
  return (
    <section
      className={cn(
        "container tw:flex tw:flex-col",
        "tw:max-md:!p-5 tw:max-md:gap-4",
        "tw:md:!p-6 tw:md:gap-6",
      )}
    >
      {children}
    </section>
  );
}
